import { render } from "./DetalleDatosGenerales.vue?vue&type=template&id=3d3ab03f&scoped=true&ts=true"
import script from "./DetalleDatosGenerales.vue?vue&type=script&lang=ts"
export * from "./DetalleDatosGenerales.vue?vue&type=script&lang=ts"

import "./DetalleDatosGenerales.vue?vue&type=style&index=0&id=3d3ab03f&scoped=true&lang=scss"

import exportComponent from "C:\\AgentesAzure\\SVRAPPHIR04\\vsts-agent-win-x64-4.261.0\\_work\\6\\s\\hircasa-srp-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3ab03f"]])

export default __exports__